function arraysAreEqual(a: unknown[], b: unknown[]): boolean {
	if (a.length !== b.length) return false
	const sortedA = [...a].sort()
	const sortedB = [...b].sort()
	return sortedA.every((v, ix) => v === sortedB[ix])
}

function equal(a: unknown, b: unknown) {
	if (Array.isArray(a) && Array.isArray(b)) {
		return arraysAreEqual(a, b)
	}
	return a === b
}

export default function onlyChangedValues<O extends { [key: string]: unknown }, N extends { [key: string]: unknown }>(
	oldData: O,
	newData: N,
): Partial<N> {
	return Object.entries(newData).reduce((changedData, [key, newValue]) => {
		const oldValue = oldData[key]
		return equal(oldValue, newValue) ? changedData : { ...changedData, [key]: newValue }
	}, {})
}
